module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/68aaf83d0fb349162cb74ab60ff3852b.png";